"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styledComponents_1 = require("../styledComponents");
const TransactionCard = ({ data }) => {
    return (react_1.default.createElement(styledComponents_1.TransactionCardContainer, null,
        react_1.default.createElement(material_1.Table, null, Object.keys(data).map((e, i) => {
            return (react_1.default.createElement(styledComponents_1.TransactionTableRow, { key: i, sx: { height: '35px' } },
                react_1.default.createElement(styledComponents_1.TransactionLabel, { sx: { borderBottom: 0, margin: 0, padding: 0 } }, e),
                react_1.default.createElement(styledComponents_1.TransactionTableCell, { sx: { borderBottom: 0, margin: 0, padding: 0 } }, data[e])));
        }))));
};
exports.default = TransactionCard;
